<script>
  export let bars = [];
</script>

<div class="fullBar">
  <div class="fullBar--chart">
    {#each bars as b}
      <div class="fullBar--bar {b.class}" style="width: {b.perc}%; flex: 0 0 {b.perc}%;" />
    {/each}
  </div>
  <div class="fullBar--legend">
    {#each bars as b}
      <span class="{b.class}">{b.label}</span>
    {/each}
  </div>
</div>

<style>
.fullBar {
  display: block;
  height: auto;
  position: relative;
  width: 100%;
}

.fullBar--chart {
  display: flex;
  flex-wrap: nowrap;
  height: 75px;
  position: relative;
}

.fullBar--bar {
  background: var(--clean) center center no-repeat;
  background-size: auto 75%;
  display: block;
  height: 75px;
}

.fullBar--bar.meloni {
  background-color: var(--meloni);
  background-image: url(/img/meloni-clean.webp);
}

.fullBar--bar.schlein {
  background-color: var(--schlein);
  background-image: url(/img/schlein-clean.webp);
}

.fullBar--bar.positive {
  background-color: var(--positive);
  background-image: url(/img/positive-clean.webp);
}

.fullBar--bar.negative {
  background-color: var(--negative);
  background-image: url(/img/negative-clean.webp);
}

.fullBar--bar.neutral {
  background-color: var(--neutral);
  background-image: url(/img/neutral-clean.webp);
}

.fullBar--legend {
  display: block;
  font-family: 'Fira Mono', monospace;
  font-size: 12px;
  font-weight: 500;
  min-height: 20px;
  line-height: 20px;
  padding: 0 10px;
  text-align: center;
  text-transform: uppercase;
  top: 100%;
}

.fullBar--legend span {
  display: block;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.fullBar--legend .meloni {
  color: var(--meloni);
}

.fullBar--legend .schlein {
  color: var(--schlein);
}

.fullBar--legend .positive {
  color: var(--positive);
}

.fullBar--legend .negative {
  color: var(--negative);
}

.fullBar--legend .neutral {
  color: var(--neutral);
}

@media screen and (min-width: 768px) {
  .fullBar--legend span {
    display: inline;
  }

  .fullBar--legend span::after {
    color: var(--dark);
    content: ',';
  }

  .fullBar--legend span:last-child::after {
    content: '.';
  }
}
</style>